import { itemHandler } from '../handlers/item_handler'

function initItemTriggers() {
    const itemTriggerElements = document.querySelectorAll('[download-item="item-trigger"]')
    itemTriggerElements.forEach((element) => {
        element.addEventListener('click', (e) => {
            itemHandler(element)
        })
    })
}

export { initItemTriggers }
